export default {
  get apiUrl () {
    let useSslDev = false
    let useSslProd = true
    return 'https://2ris0v850m.execute-api.us-east-1.amazonaws.com/Prod/api/admin'
    // return process.env.NODE_ENV === 'production'
    //   ? (useSslProd === true ? 'https://2ris0v850m.execute-api.us-east-1.amazonaws.com/Prod/api/admin' : 'http://g7nag2z4v8.execute-api.us-east-2.amazonaws.com/Prod/api/admin')
    //   : (useSslDev === true ? 'https://localhost:9443/api/admin' : 'http://localhost:9000/api/admin')
  },
  get env () {
    return process.env.NODE_ENV
  }
}



// WEBPACK FOOTER //
// ./src/helpers/config.js